import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './modules/AppRouter';

const containerNode = document.getElementById('container');
ReactDOM.render(<AppRouter />, containerNode);
